import React from 'react'
import PropTypes from 'prop-types'
import { EditorState } from 'draft-js'
import IconButton from 'material-ui/IconButton'
import ClearIcon from 'material-ui/svg-icons/content/clear'

const styles = {
  iconWrapper: {
    // minWidth: '40px',
    width: null,
    height: null,
    padding: 0,
  },
  iconStyles: {
  },
}

const ResetEditorButton = props => (
  <IconButton
    tooltip="Clear editor"
    tooltipPosition="top-left"
    onClick={() => props.updateParentBodyState(EditorState.createEmpty())}
    style={styles.iconWrapper}
  >
    <ClearIcon />
  </IconButton>
)

ResetEditorButton.propTypes = {
  updateParentBodyState: PropTypes.func.isRequired,
}

export default ResetEditorButton



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/StyleControls/ResetEditorButton.js